/**
 * Sexy Hair Focus Trap
 *
 * Lightweight focus trap that re-queries focusable elements on every Tab,
 * so it stays correct when content loads into a drawer after open (e.g.
 * predictive search results). Dawn's global `trapFocus` captures first/last
 * at init time and misses dynamic content; this trap is meant to layer on
 * top for surfaces with that pattern.
 *
 * Usage:
 *   SexyhairFocusTrap.trap(containerEl, returnFocusEl);
 *   SexyhairFocusTrap.release({ returnFocus: true });
 */
(function () {
  if (window.SexyhairFocusTrap) return;

  var FOCUSABLE = [
    'a[href]:not([disabled])',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'details > summary:first-of-type',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  var state = null;

  function focusable(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(FOCUSABLE),
      function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      }
    );
  }

  function onKeydown(event) {
    if (!state || event.key !== 'Tab') return;

    var els = focusable(state.container);
    if (!els.length) {
      event.preventDefault();
      return;
    }
    var first = els[0];
    var last = els[els.length - 1];
    var active = document.activeElement;

    if (event.shiftKey) {
      if (active === first || !state.container.contains(active)) {
        event.preventDefault();
        last.focus();
      }
    } else if (active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function trap(container, trigger) {
    if (!container) return;
    if (state) release({ returnFocus: false });

    // Clear Dawn's static trap so its captured first/last don't fight ours.
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();

    state = { container: container, trigger: trigger || null };
    container.addEventListener('keydown', onKeydown);
  }

  function release(opts) {
    if (!state) return;
    var trigger = state.trigger;
    state.container.removeEventListener('keydown', onKeydown);
    state = null;
    if (opts && opts.returnFocus && trigger && typeof trigger.focus === 'function') {
      trigger.focus();
    }
  }

  window.SexyhairFocusTrap = { trap: trap, release: release };
})();
